import { createReducer } from 'redux-act';

import {
  PRODUCT_FETCH_DATA_INIT,
  PRODUCT_FETCH_DATA_SUCCESS,
  PRODUCT_FETCH_DATA_FAIL,
  PRODUCT_FETCH_SHAPE_INIT,
  PRODUCT_FETCH_SHAPE_SUCCESS,
  PRODUCT_FETCH_SHAPE_FAIL,
  PRODUCT_DELETE_INIT,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  PRODUCT_CLEAR_DATA,
  PRODUCT_CREATE_INIT,
  PRODUCT_CREATE_SUCCESS,
  PRODUCT_CREATE_FAIL,
  PRODUCT_MODIFY_INIT,
  PRODUCT_MODIFY_SUCCESS,
  PRODUCT_MODIFY_FAIL,
  PRODUCT_CLEAN_UP,
  PRODUCT_CLEAR_DATA_LOGOUT,
  PRODUCT_EXPORT_INIT,
  PRODUCT_EXPORT_SUCCESS,
  PRODUCT_EXPORT_FAIL,
  PRODUCT_CLEAN_UP_FORM,
  PRODUCT_FETCH_RATINGS_INIT,
  PRODUCT_FETCH_RATINGS_SUCCESS,
  PRODUCT_FETCH_RATINGS_FAIL,
  PRODUCT_FETCH_RATING_INIT,
  PRODUCT_FETCH_RATING_SUCCESS,
  PRODUCT_FETCH_RATING_FAIL,
} from 'state/actions/product';

const initialState = {
  list: [],
  product: null,
  shape: new Set(),
  category: 'all',
  tag: 'all',
  linkfilter: 'all',
  floor: 'all',
  ratings: [],
  poiRating: null,
  loading: false,
  downloading: false,
  error: {
    errors: null,
    message: '',
  },
  success: false,
  deleted: false,
};

export const productsReducer = createReducer(
  {
    [PRODUCT_FETCH_DATA_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_FETCH_DATA_SUCCESS]: (state, payload) => {
      return {
        ...state,
        list: payload.list || [],
        product: payload.product,
        loading: false,
        error: {
          errors: null,
          message: '',
        },
      };
    },
    [PRODUCT_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_FETCH_SHAPE_INIT]: (state) => {
      const isEmpty = Object.keys(state).length === 0;

      return {
        ...(isEmpty ? initialState : state),
        loading: true,
      };
    },
    [PRODUCT_FETCH_SHAPE_SUCCESS]: (state, payload) => ({
      ...state,
      shape: payload.shape || new Set(),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PRODUCT_FETCH_SHAPE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      deleted: true,
    }),
    [PRODUCT_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [PRODUCT_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.push(...payload.data),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
    }),
    [PRODUCT_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_MODIFY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem._id === payload.id) {
              return (elem = payload.product);
            }
            return elem;
          }),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
    }),
    [PRODUCT_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_CLEAN_UP]: (state) => ({
      ...state,
      list: [],
      category: 'all',
      tag: 'all',
      floor: 'all',
      linkfilter: 'all',
      error: {
        errors: null,
        message: '',
      },
      success: false,
      deleted: false,
    }),
    [PRODUCT_CLEAN_UP_FORM]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: false,
      deleted: false,
    }),
    [PRODUCT_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [PRODUCT_EXPORT_INIT]: (state) => ({
      ...state,
      downloading: true,
    }),
    [PRODUCT_EXPORT_SUCCESS]: (state) => ({
      ...state,
      downloading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PRODUCT_EXPORT_FAIL]: (state, payload) => ({
      ...state,
      downloading: false,
      error: payload.error,
    }),
    [PRODUCT_FETCH_RATINGS_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_FETCH_RATINGS_SUCCESS]: (state, payload) => ({
      ...state,
      ratings: payload.ratings || [],
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PRODUCT_FETCH_RATINGS_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PRODUCT_FETCH_RATING_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PRODUCT_FETCH_RATING_SUCCESS]: (state, payload) => ({
      ...state,
      poiRating: payload.poiRating || null,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PRODUCT_FETCH_RATING_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
  },
  initialState
);
